import React, { useState, useEffect } from "react"
import { css, logTool } from "@jsUtils"

import Styles from "./fademounter.module.scss"

const log = logTool()

const FadeMounter = props => {
  const { children, showing, unMountedCallback } = props

  const [showState, setShowState] = useState(false)

  useEffect(() => {
    if (showing) {
      setShowState(true)
    }
    // typically this will fire before the onAnimationEnd, so we do not
    // want to call unMountedCallback until the transition is done
    return () => {
      log({ showing, showState })
    }
  }, [showing])

  const onAnimationEnd = () => {
    // typically this will fire after the cleanup function in useEffect up top
    if (!showing) {
      // slightly redundant
      setShowState(false)
      if (unMountedCallback) unMountedCallback()
    }
  }

  return (
    showState && (
      <div
        className={css(showing && Styles.mountIn, !showing && Styles.mountOut)}
        onAnimationEnd={onAnimationEnd}
      >
        {children}
      </div>
    )
  )
}

export default FadeMounter
